import { useTranslation } from '../i18n';

// Fixed top-right toast that announces save state. Pair with useSaveIndicator.
// Renders nothing when status === 'idle'.
//
// CSS: .toast-region + .toast--{saving,saved,error} live in globals.css.
export function SaveToast({ status }) {
  const { t } = useTranslation();
  if (status === 'idle') return null;
  const label =
    status === 'saving' ? t('common.saveSaving') :
    status === 'saved'  ? t('common.saveSaved')  :
                          t('common.saveError');
  return (
    <div className="toast-region" aria-live="polite">
      <div className={`toast toast--${status}`} role="status">{label}</div>
    </div>
  );
}
